'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('Authentication', []);
_angular2.default.module('Authentication').factory('AuthenticationService', ['Base64', '$state', '$http', '$cookieStore', '$rootScope', '$timeout', '$q', '$location', 'User', 'FunctionService', 'CONST', function (Base64, $state, $http, $cookieStore, $rootScope, $timeout, $q, $location, User, FunctionService, CONST) {

  var service = {};

  service.Login = function (scope, callback) {

    scope.username = undefined;
    scope.password = undefined;

    _angular2.default.forEach(scope.vm.userFields, function (value, key) {

      if (value.id === 'username') {

        scope.username = value.value();
      } else if (value.id === 'password') {

        scope.password = value.value();
      }
    });

    var respond = {};

    $http({
      method: "GET",
      url: '' + WEBSERVICEURL + '/dataagility/api/service.person/checkUser',
      params: { authToken: btoa(scope.username + ":" + scope.password) }
    }).success(function (response) {

      if (response.data.length === 0) {

        respond.message = 'Username or password is incorrect';
      } else {

        respond = { success: response.data };
        USER.email = response.data.email;
        USER.name = response.data.firstname + ' ' + response.data.lastname;
        USER.specialty = response.data.specialty;
        USER.role = response.data.dtype;
        USER.worklist = response.data.worklist;
        USER.id = response.data.id;
        USER.token = response.data.token;
        USER.roleId = response.data.roleId;
        USER.activeDirectoryToken = response.data.activeDirectoryToken;
        USER.campus = response.data.campus;
        USER.codingOperationsTeam = response.data.codingOperationsTeam;
        User.setUser(USER.codingOperationsTeam, USER.name, USER.email, USER.specialty, USER.role, USER.worklist, USER.id, USER.token, USER.roleId, USER.activeDirectoryToken, false, USER.campus);
      }
      callback(respond);
    }).error(function (response) {
      respond.message = 'An error has occurred!';
      callback(respond);
    });
  };

  service.Decrypt = function (input) {
    var output = "";
    var chr1,
        chr2,
        chr3 = "";
    var enc1,
        enc2,
        enc3,
        enc4 = "";
    var i = 0;

    var base64test = /[^A-Za-z0-9\+\/\=]/g;
    if (base64test.exec(input)) {
      // console.log("There were invalid base64 characters in the input text.\n" +
      //   "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
      //   "Expect errors in decoding.");
    }
    var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    do {
      enc1 = keyStr.indexOf(input.charAt(i++));
      enc2 = keyStr.indexOf(input.charAt(i++));
      enc3 = keyStr.indexOf(input.charAt(i++));
      enc4 = keyStr.indexOf(input.charAt(i++));

      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }

      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);

    return output;
  };

  service.UpdateUser = function () {
    var globals = $cookieStore.get('globals') || {};
    if (globals.currentUser) {
      USER.name = globals.currentUser.name;
      USER.email = globals.currentUser.email;
      USER.specialty = globals.currentUser.specialty;
      USER.role = globals.currentUser.role;
      USER.id = globals.currentUser.id;
      USER.token = globals.currentUser.token;
      USER.roleId = globals.currentUser.roleId;
      USER.activeDirectoryToken = globals.currentUser.activeDirectoryToken;
      USER.initialLogin = globals.currentUser.initialLogin;
      USER.campus = globals.currentUser.campus;
      USER.codingOperationsTeam = globals.currentUser.codingOperationsTeam;
    }
    return USER;
  };

  service.UpdateUserToken = function () {

    $rootScope.globals = $cookieStore.get('globals') || {};

    var deferred = $q.defer();

    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    if ($rootScope.stopTokenRefresh === undefined && $rootScope.globals.currentUser.initialLogin === undefined) {
      $http.post(WEBSERVICEURL + '/dataagility/api/service.usersession/token', $rootScope.globals.currentUser.token).then(function successCallback(response) {
        $rootScope.globals.currentUser.initialLogin = true;
        $rootScope.globals.currentUser.token = response.data;
        $cookieStore.put('globals', $rootScope.globals);
        // Update v2 cookie with updated token
        document.cookie = 'globals=' + JSON.stringify($rootScope.globals) + '; path=/' + V2CONTEXT + '/;';
        var currentUser = User.getUser();
        User.setUser(currentUser.codingOperationsTeam, currentUser.name, currentUser.email, currentUser.specialty, currentUser.role, currentUser.worklist, currentUser.id, response.data, currentUser.roleId, currentUser.activeDirectoryToken, true, currentUser.campus);
        FunctionService.getFunctions(currentUser.roleId ? currentUser.roleId : $rootScope.globals.currentUser.roleId).then(function successCallback(functionsResponse) {
          deferred.resolve(functionsResponse.data);
        });
      }, function errorCallback(response) {
        if (response.status === 401) {
          window.location.replace(window.location.origin + '/login?logout=true');
        }
      });
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  };

  service.SetCredentials = function (codingOperationsTeam, email, name, speciality, role, worklist, id, token, roleId, redirectRoute, activeDirectoryToken, initialLogin, campuses) {

    var spec,
        uCampus,
        list = worklist; // In case worklist is null

    if (speciality) {
      spec = speciality.indexOf(',') > -1 ? speciality.split(',') : speciality;
    } else {
      spec = "";
    }

    if (campuses) {
      uCampus = campuses.indexOf(',') > -1 ? campuses.split(',') : campuses;
    } else {
      uCampus = "";
    }

    if (worklist) {
      list = worklist.indexOf(',') > -1 ? worklist.split(',') : []; // Worklist isn't null, so make list an array
    }

    if (Array.isArray(list) && list.length === 0) {
      list.push(worklist); // A single worklist
    }

    USER.codingOperationsTeam = codingOperationsTeam;
    USER.email = email;
    USER.name = name;
    USER.specialty = spec;
    USER.role = role;
    USER.worklist = list;
    USER.id = id;
    USER.token = token;
    USER.roleId = roleId;
    USER.redirectRoute = redirectRoute;
    USER.activeDirectoryToken = activeDirectoryToken;
    USER.initialLogin = initialLogin;
    USER.campus = uCampus;

    $rootScope.globals = {
      currentUser: {
        codingOperationsTeam: codingOperationsTeam,
        email: email,
        name: name,
        firstname: name.substring(0, name.indexOf(' ')),
        lastname: name.substring(name.indexOf(' ') + 1),
        speciality: spec,
        role: role,
        worklist: list,
        id: id,
        token: token,
        roleId: roleId,
        redirectRoute: redirectRoute,
        activeDirectoryToken: activeDirectoryToken,
        initialLogin: initialLogin,
        campus: uCampus
      }
    };

    $rootScope.USER = USER;

    $cookieStore.put('globals', $rootScope.globals);
    User.setUser(codingOperationsTeam, name, email, spec, role, list, id, token, roleId, activeDirectoryToken, initialLogin, uCampus);
  };

  service.ClearCredentials = function (logoutType) {
    console.log('service.ClearCredentials...');
    if ($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.token) {
      $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
      $http.post(WEBSERVICEURL + '/dataagility/api/service.usersession/logout/' + logoutType, $rootScope.globals.currentUser.token);
      $state.transitionTo("logout");
    }
    $rootScope.globals = {};
    $cookieStore.remove('globals');
  };

  return service;
}]).factory('Base64', function () {
  /* jshint ignore:start */

  var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  return {
    encode: function encode(input) {
      var output = "";
      var chr1,
          chr2,
          chr3 = "";
      var enc1,
          enc2,
          enc3,
          enc4 = "";
      var i = 0;

      do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
      } while (i < input.length);

      return output;
    },

    decode: function decode(input) {
      var output = "";
      var chr1,
          chr2,
          chr3 = "";
      var enc1,
          enc2,
          enc3,
          enc4 = "";
      var i = 0;

      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      var base64test = /[^A-Za-z0-9\+\/\=]/g;
      if (base64test.exec(input)) {
        window.alert("There were invalid base64 characters in the input text.\n" + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" + "Expect errors in decoding.");
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

      do {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));

        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;

        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }

        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
      } while (i < input.length);

      return output;
    }
  };

  /* jshint ignore:end */
});


// WEBPACK FOOTER //
// ./client/app/authentication.module.js